import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { instantAccess, volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-223" data-mp="2x0qo1tmch8bb">
      <div className="mx-auto w-full max-w-4xl" data-id="element-224" data-mp="2x3cufpxi1hry">
        <SectionHeading tone="light" eyebrow="Cosa c’è dentro" title="Cosa troverai dentro Protocollo Clinico Sicuro™" data-id="element-225" data-mp="2t0ganvw83fmf" />

        <ol className="mt-9 space-y-4" data-id="element-226" data-mp="2o2emiwjxwq43">
          {volumes.map(volume => <li key={volume.number} className="rounded-2xl border border-ink/10 bg-white p-5" data-id="element-227" data-mp="2j7sbwvlon1l2">
              <span className="inline-block rounded-full bg-ink px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-gold" data-id="element-228" data-mp="29byzrdbvla3t">
                {volume.number}
              </span>
              <h3 className="mt-3 font-display text-[18px] font-bold leading-tight text-ink sm:text-xl" data-id="element-229" data-mp="20b9aksh4ehz2">
                {volume.title}
              </h3>
              <p className="mt-2 text-[14.5px] leading-relaxed text-ink/65" data-id="element-230" data-mp="3342v3aictsg3">
                {volume.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-ink p-6 sm:p-8" data-id="element-231" data-mp="2u5zd2o6kvdt1">
          <h3 className="text-center font-display text-xl font-bold text-cream sm:text-2xl" data-id="element-232" data-mp="2y6ja7rr5ihf6">
            📲 Inoltre, riceverai accesso immediato a:
          </h3>
          <ul className="mt-6 space-y-3" data-id="element-233" data-mp="3lwx2njdneiaa">
            {instantAccess.map(item => <li key={item.text} className="flex gap-3 rounded-xl border border-ink-line bg-ink-soft p-4" data-id="element-234" data-mp="3quotsb6gy0df">
                <span className="text-lg leading-none" aria-hidden="true" data-id="element-235" data-mp="3hua7p9lokh8v">
                  {item.icon}
                </span>
                <p className="text-[14px] leading-snug text-cream/75" data-id="element-236" data-mp="21f8v5pq67x1s">
                  {item.text}
                </p>
              </li>)}
          </ul>
          <p className="mx-auto mt-6 max-w-xl text-center text-[14.5px] leading-relaxed text-cream/70" data-id="element-237" data-mp="byvhdkxz7dw8">
            Qualsiasi riabilitazione complessa arrivi nel tuo studio… avrai un
            sistema chiaro per valutarla, pianificarla ed eseguirla con maggiore
            sicurezza.
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-238" data-mp="3udxqao7ixvxj">
          <CTAButton label="Voglio accedere a tutto il sistema" data-id="element-239" data-mp="3ub1ryyrrl58k" />
        </div>
      </div>
    </section>;
}